// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-list-header{margin-left:auto;margin-right:auto;width:96vw}.order-list-header__btn .v-btn__content span{text-align:left!important}.order-list-header .selected-header{border-bottom:3px solid #d8d8d8;border-radius:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
